var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.value,
          expression: "value"
        }
      ],
      staticClass: "non-dom-remove-dialog"
    },
    [
      _c("div", {
        staticClass: "non-dom-remove-dialog__backdrop",
        on: { click: _vm.close }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "non-dom-remove-dialog__content" },
        [
          _c("q-btn", {
            staticClass: "non-dom-remove-dialog__close",
            attrs: { icon: "close", round: "" },
            on: { click: _vm.close }
          }),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }